import { useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { t } from "../i18n/translations";
import "./OrderSuccessScreen.css";

function ReservationSuccessScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const { language } = useSelector((state) => state.language);

  const reservation = location.state?.reservation;

  useEffect(() => {
    if (!reservation) navigate("/", { replace: true });
  }, [reservation, navigate]);

  if (!reservation) return null;

  const isConfirmed = reservation.status === "confirmed";

  return (
    <div className="success-animation">
      <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
        <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
      </svg>

      <h2 className="mt-3 text-center">
        {isConfirmed
          ? t("reservationSuccessTitle", language)
          : t("reservationPendingTitle", language)}
      </h2>

      <p className="text-center">
        {isConfirmed
          ? t("reservationConfirmedNote", language)
          : t("reservationPendingNote", language)}
      </p>

      <div className="order-tracking">
        <h3 className="order-tracking-title">{t("reservationDetailsLabel", language)}</h3>

        <p className="order-tracking-subtitle">
          {reservation.event ? `🎉 ${reservation.event.title} · ` : ""}
          {new Date(reservation.date).toLocaleDateString(
            language === "hu" ? "hu-HU" : language,
            { month: "long", day: "numeric" },
          )}{" "}
          · {reservation.time?.slice(0, 5)}
        </p>

        <p className="order-tracking-subtitle">
          {t("reservationPartySizeLabel", language)}: <strong>{reservation.party_size}</strong>
        </p>
      </div>

      <div className="text-center">
        <Link to={`/reservations/${reservation.cancellation_token}`}>
          {t("manageReservationLink", language)}
        </Link>
      </div>

      <div className="text-center mt-2">
        <Link to="/">{t("backToMenu", language)}</Link>
      </div>
    </div>
  );
}

export default ReservationSuccessScreen;
